/* eslint-disable react/prop-types */
import React, {  useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Form from 'component/utils/Form'
import Modal from 'component/utils/Modal'
import WarningModal from 'component/scheduleBlock/WarningModal'
import RadioGroup from '../RadioGroup'
import RadioButton from '../Radio'
import Select from '../Select/Select'
import { isEmpty } from 'utils/validations'


const PictogramAddModal = ({
  closeModal,

  action,
  translate,
  attribute,
}) => {


  const [status, setStatus] = useState()
  const [defaultStatus, setDefaultStatus] = useState()
  const [warningModal,setWarningModal] = useState(false)

  const isButtonDisabled = isEmpty(status) || status === defaultStatus
  const isSingle = Array.isArray(attribute) && attribute.length === 1 || !Array.isArray(attribute)
  const handleSubmit = () => {
  
    const form = {permissionType: status, dsMission: Array.isArray(attribute) ? attribute : [attribute.dsMission]}
    action(form)
    
  }

  useEffect(() => { 
    if(isSingle ) {
      const permissionType = attribute.permissionType ?? attribute[0]
      
      switch(permissionType) {
        case 'VERIFICACAO':
          setStatus(1)
          setDefaultStatus(1)
          break
        default:
          setStatus(0)
          setDefaultStatus(0)
      }
    }
  }, [])

  const optionsPermissionTypes = [
    { value: 0, label: 'Aprovação',},
    { value: 1, label: 'Verificação'},
  ]

  const handleCloseModal = () => {
    if(!isEmpty(status) && status !== defaultStatus) {
      setWarningModal(true)
    }
    else {
      closeModal()
    }
  }
  const renderWarningModalWeekly = () => {

    if(!warningModal) return
    const handleConfirm = () => {
      setStatus()
      setWarningModal(false)
      closeModal()
    }

    const handleCancel = () => {
      setWarningModal(false)
    }

    return (
      <WarningModal
        customClass='pictogram-warning-modal'
        handleCancel={handleCancel}
        handleConfirm={handleConfirm}
        customText='Gostaria de sair sem salvar a tela de cadastro mesmo assim?'
        translate={translate}
        
      />
    )

  }

  return (
    <>
 
      {renderWarningModalWeekly()}
    
      <Modal
        modalWidth={'408px'}
        onCloseModal={handleCloseModal}
        size='md'
        under
        className={`use-consume-approvers-modal uca-edit  ${warningModal ? 'hide-shadow' : ''}`}
      >
        <h3 style={{fontSize: '24px', marginBottom:'25px', marginTop: '-1px', paddingTop: '4px'}}>
          <strong style={{color: 'black'}}> {Array.isArray(attribute) && attribute.length > 1 ? "Editar permissões" : "Editar permissão"} </strong>
        </h3>


        { isSingle &&
          <Select
          label='Missão'
          required
          placeholder={Array.isArray(attribute) && attribute.length > 1 ? translate("customSelect.multiLabel") : attribute.dsMission ?? attribute.id}
          fill
          disabled
          
          />
        }

        { !isSingle && <p style={{color: '#222020', fontWeight: 600, fontSize: "16px"}}> {attribute.length} missões selecionadas</p>}

      

           <div className='radio-group-title-container'> <span className='radio-group-title'>Tipo de permissão</span> </div>  
           <RadioGroup

              className={
                 'use-consume-approvers-spacing'
              }
            >
              {optionsPermissionTypes.map((val, i) => (
                <RadioButton
                  key={i}
                  checked={status === val.value}
                  defaultChecked={!!val.checked}
                  onClick={() => setStatus(val.value) }
                  name={`radioGroup.${val.value}`}
                  label={val.label}
                />
              ))}
            </RadioGroup>
       

        
        <div className='mission-block-new-modal-actions'>

          <button
            
            disabled={isButtonDisabled}
            onClick={handleSubmit}
            className='mission-save'
          >
            {translate('save_button_label')}
          </button>

          <button
            onClick={handleCloseModal}
            className='mission-cancel'
          >
          {translate('cancel_button_label')}
          </button>


        </div>
      </Modal>
    </>
    
 )
}

PictogramAddModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
  handleAttributeAlreadyExists: PropTypes.func,
  attribute: PropTypes.object,
  user:PropTypes.object,
  action: PropTypes.func,
  fetchMissionsOptions: PropTypes.array,
  options: PropTypes.object,
  attributeAlreadyExists: PropTypes.func

}


export default Form()(PictogramAddModal)

export { PictogramAddModal }
